<template>

  <div class="message">
    <message-container></message-container>
  </div>
</template>
<script>
import MessageContainer from '@/components/message/Container.vue'
export default {
  name: 'message',
  components: {
    MessageContainer
  }
}
</script>
<style lang="stylus">
.message
  height 100%
</style>
